import { CommonCheckBox } from '@/components/_dashboard/promotion/formik/commonCheckBox';
import { CommonInput } from '@/components/_dashboard/promotion/formik/commonInput';
import {
    getVoucherDetailsValidationList
} from '@/components/_dashboard/promotion/tools';
import { getErrorMessage } from '@/utils/stringHelper';
import { Grid2 } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { IPromoProps } from '../../type';
import { renderContent, tabContent } from '../tabContent';

export const LuckyDrawDetails: React.FC<IPromoProps> = (props) => {
    const { formik, setCanMoveFunc, setFieldTouchedNameFunc } = props;
    // get type from url params
    const { values } = formik;

    const canMove = useCallback(async () => {
        // name is required
        // numberOfDeals is required and greater than 0
        let message = '';
        let canMove = true;
        try {
            const list = getVoucherDetailsValidationList(values);
            for (const path of list) {
                await setFieldTouchedNameFunc(path);
            }
        } catch (e) {
            message = getErrorMessage(e);
            canMove = false;
        }
        return {
            message: message,
            canMove: canMove
        };
    }, [values, setFieldTouchedNameFunc]);

    const wrappedCanMove = useCallback(() => canMove(), [canMove]);
    useEffect(() => {
        setCanMoveFunc(() => wrappedCanMove);
    }, [setCanMoveFunc, wrappedCanMove]);


    const luckyDrawContents: tabContent[] = [
        {
            mdSize: 12,
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'prizeDescription'}
                    type="text"
                    label="Prize Description"
                    placeholder="Please enter the description of the prize"
                    multiline={true}
                />
            )
        },
        {
            mdSize: 12,
            node: {
                node: (
                    <CommonInput
                        formik={formik}
                        fieldPath={'minimumAmount'}
                        type="number"
                        endAdornment="AUD"
                        label="Minimum Spend"
                        placeholder="Spend $50 or more to get 10% off"
                        TooltipText="Minimum Spend required to enter the lucky draw"
                    />
                )
            }
        },
        {
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'winCountLimitPerPerson'}
                    type="number"
                    label="Win Limit Per Customer"
                    placeholder="Maximum Number of Wins Allowed Per User"
                    TooltipText="Maximum Number of Wins Allowed Per User"
                />
            )
        },
        {
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'entryLimitPerUser'}
                    type="number"
                    label="Entry Limit Per Customer"
                    placeholder="Maximum Number Of Entries Allowed Per User"
                    TooltipText="Maximum Number Of Entries Allowed Per User"
                />
            )
        },
        {
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'winnerCount'}
                    type="number"
                    label="Global Winner Count"
                    placeholder="Total Global Win Count For This Lucky Draw"
                    TooltipText="Total Global Win Count For This Lucky Draw"
                />
            )
        },
        {
            node: (
                <CommonInput
                    formik={formik}
                    fieldPath={'winPercentage'}
                    type="number"
                    label="Winning Probability"
                    endAdornment="%"
                    placeholder="Enter percentage (e.g. 10 for 10%)"
                    TooltipText="This percentage determines whether a customer wins anything at all. If they win, the system will then randomly select which specific prize (promotion) they receive based on each prize's individual probability distribution."
                />
            )
        },
        {
            mdSize: 12,
            node: (
                <CommonCheckBox
                    formik={formik}
                    fieldPath="isEntryAutomatic"
                    title="Automatic"
                    label="Automatically enter into lucky draw"
                />
            )
        },
        {
            mdSize: 12,
            node: (
                <CommonCheckBox
                    formik={formik}
                    fieldPath="isPaymentRequired"
                    title="Payment First"
                    label="Entry requires pre-payment"
                />
            )
        }
    ];


    const render = (): React.ReactNode => {
        return renderContent(luckyDrawContents);
    };
    return (
        <Grid2 sx={{ width: '100%' }} container spacing={1}>
            {render()}
        </Grid2>
    );
};
